import Image from 'next/image';

import gdpr from '@public/images/signup/gdpr_Engagement.webp';
// Images
import pentest from '@public/images/signup/pentest.svg';

import useTranslation from '@/utils/hooks/translation/useTranslation';

// Components
import H2 from '@/components/base/Headings/H2';

const SocialProfilesDataReassurance = () => {
    const { t } = useTranslation('signup_funnel');

    return (
        <div className="flex flex-col">
            <div className="flex flex-col space-y-4">
                <H2>{t('connect_social_profiles.reassurance.title')}</H2>
                <p className="font-GMedium text-sm text-icoGray-500">
                    {t('connect_social_profiles.reassurance.subtitle')}
                </p>
            </div>
            <span className="mt-10 flex flex-col items-center gap-5 sm:flex-row sm:justify-normal lg:flex-col xl:flex-row">
                <Image alt="PenTest" width={180} height={100} src={pentest} className="block" />
                <Image alt="GDPR" width={100} height={100} src={gdpr} className="block" />
            </span>
        </div>
    );
};

export default SocialProfilesDataReassurance;
